module.exports = __webpack_public_path__ + "media/images/emblems/Volketswil-blazon-a9a44ca4876fe0e8e798d8f23c808065.svg";